import { RehearsalSceneItem } from './rehearsal-scene-item';

export class RehearsalScene {
    public id: number = 0;
    public name: string = '';
    public items: RehearsalSceneItem[] = [];
    public orderIndex: number = 0;
    public required: boolean = false;
    public notes: string = '';

    public create(json: any): RehearsalScene {
        if (json == null) {
            throw Error('No json provided');
        }

        const entity = new RehearsalScene();
        entity.id = json.id;
        entity.name = json.name;

        if(json.items && Array.isArray(json.items) && json.items.length > 0) {
            const items = json.items.map(item => new RehearsalSceneItem().create(item));
            items.sort((a, b) => a.name.localeCompare(b.name));
            entity.items = items;
        } else if(json.requirements && Array.isArray(json.requirements) && json.requirements.length > 0) {
            const items = json.requirements.map(item => new RehearsalSceneItem().create(item));
            items.sort((a, b) => a.name.localeCompare(b.name));
            entity.items = items;
        }else {
            entity.items = [];
        }

        entity.required = json.required ?? false;

        entity.orderIndex = json.orderIndex;

        entity.notes = json.notes;

        return entity;
    }

}
